function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTulUlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.23,
    height: 78.768,
    viewBox: "0 0 269.23 78.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "TULU logo"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 913"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4363",
    d: "M2312.5 941.6h33.272v3.948H2331.3v39.913h-4.323v-39.917H2312.5z",
    transform: "translate(-2220.278 -909.948)",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4364",
    d: "M2374.945 978.188q3.666 3.76 10.182 3.76t10.151-3.76q3.633-3.758 3.634-10.527V941.6h4.323v26.065q0 8.522-4.793 13.346t-13.315 4.825q-8.521 0-13.346-4.825t-4.825-13.346V941.6h4.323v26.065q0 6.763 3.666 10.523z",
    transform: "translate(-2227.993 -909.948)",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4365",
    d: "M2432.146 941.669h4.324v39.913h19.3v3.884h-23.622z",
    transform: "translate(-2237.227 -909.958)",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4366",
    d: "M2484.445 978.188q3.667 3.76 10.182 3.76t10.151-3.76q3.634-3.758 3.635-10.527V941.6h4.323v26.065q0 8.522-4.794 13.346t-13.315 4.825q-8.522 0-13.346-4.825t-4.825-13.346V941.6h4.323v26.065q.001 6.763 3.666 10.523z",
    transform: "translate(-2243.505 -909.948)",
    style: {
      fill: "#040405"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4367",
    d: "M2244.435 972.692a20.222 20.222 0 0 1-14.518-6.081l2.543-2.5a16.8 16.8 0 1 0 23.755-23.76l2.5-2.544a20.368 20.368 0 0 1-14.283 34.889z",
    transform: "translate(-2208.58 -909.411)",
    style: {
      fill: "#c80045"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 909"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4368",
    d: "M2242.3 978.62a28.475 28.475 0 0 1-27.457-21.015l3.445-.929a24.871 24.871 0 1 0 30.418-30.526l.918-3.449a28.439 28.439 0 0 1-7.325 55.918z",
    transform: "translate(-2206.444 -907.272)",
    style: {
      fill: "#040405"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4369",
    d: "M2240.913 984.658a35.9 35.9 0 0 1-35.855-35.854h3.569a32.247 32.247 0 1 0 24.113-31.243l-.9-3.453a35.858 35.858 0 1 1 9.075 70.55z",
    transform: "translate(-2205.058 -905.89)",
    style: {
      fill: "#040405"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4370",
    d: "M2284.927 937.76a39.331 39.331 0 0 0-38.1-29.467v-3.568a42.9 42.9 0 0 1 41.551 32.141z",
    transform: "translate(-2210.976 -904.725)",
    style: {
      fill: "#040405"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulUlogo);
export default __webpack_public_path__ + "static/media/TULU logo.82a86f36fbb180a462a4d50c0027d8c6.svg";
export { ForwardRef as ReactComponent };